import Parser from 'html-react-parser';
import * as Immutable from 'immutable';
import * as React from 'react';

import { internalLinkReplace, formatHTMLRawMessageHelper } from '../../shared/helpers/internationalization';

import { ClickableMessage } from './ClickableMessage';
import { FlashMessageLinkHandlers } from './FlashMessages';

interface FlashMessageProps {
  type: string;
  links: any;
  messages: any;
  intl: any;
  inputType: any;
  needIntl: boolean;
  props: any;
  excludedLinks: Immutable.List<number>;
  parseHtml: boolean;
  linkHandlers?: FlashMessageLinkHandlers;
}

export const FlashMessage = ({
  messages,
  links,
  needIntl,
  inputType,
  intl,
  excludedLinks,
  parseHtml,
  props,
  linkHandlers,
}: FlashMessageProps) => (
  <React.Fragment>
    {messages &&
      messages.map((msg: any, key: number) => {
        if (links !== null && links.get(key)) {
          return (
            <ClickableMessage
              message={msg}
              link={links.get(key)}
              intl={intl}
              key={`flash-messages-item-${key}`}
              messageVariables={needIntl}
              InputType={inputType}
              props={props}
              excludedLinks={excludedLinks}
              linkHandlers={linkHandlers}
            />
          );
        } else {
          let newMsg = msg;
          if (parseHtml || msg.getIn?.(['options', 'parseHtml'])) {
            newMsg = Parser(msg.get('msg'), { replace: internalLinkReplace });
          } else if (needIntl && typeof msg !== 'string') {
            const intlValues = msg && msg.get('intlValues') ? msg.get('intlValues').toJS() : {};

            // To add variables to a intl string you need to add a property to the message called intlValues and then
            // Add a object with the properties. Example: {msg: 'sda', defaultMessage: 'sda', intlValues: {count: 1}}
            if (msg.get('msg')) {
              newMsg = formatHTMLRawMessageHelper(intl, {
                key: msg.get('msg'),
                defaultMessage: msg.get('defaultMessage'),
                values: intlValues,
              });
            }
          } else if (typeof msg === 'string') {
            newMsg = msg;
          } else {
            newMsg = msg && msg.get('msg');
          }

          // newMsg may contains HTML, we need to transform string to ReactNode
          if (typeof msg === 'string') {
            newMsg = Parser(msg, { replace: internalLinkReplace });
          }

          if (newMsg) {
            return (
              <li key={`flash-messages-item-${key}`} className="flash-messages__item">
                <div className="flash-messages__container">{newMsg}</div>
              </li>
            );
          } else {
            return null;
          }
        }
      })}
  </React.Fragment>
);
